import axios from "axios";
import { logout } from "../lib/auth";
import { tossUpFormTableColumn } from "../config/tossUpForm";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// トスアップフォーム一覧取得
export async function getTossUpForms(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "tossUpForms";
    const params = makeParams(tossUpFormTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const tossUpForms: dataDifine[] = response.data.fetch_data;
    const countTossUpForms: string = response.data.count_data;
    return { tossUpForms, countTossUpForms };
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム一覧取得
export async function getTossUpForm(id: string) {
  try {
    const path = "tossUpForm";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 商材編集
export async function putTossUpForm(editData: EditDataDifine) {
  try {
    const path = "tossUpForm";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム登録
export async function postTossUpForm(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "tossUpForm";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム削除
export async function deleteTossUpForm(id: string) {
  try {
    const path = "tossUpForm";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム一括質問登録
export async function postTossUpFormOptions(
  editIDs: number[],
  select_option: {
    option_name: string;
    sns_send: 0 | 1;
    required_optional: 0 | 1;
    option_type: 0 | 1 | 2 | 3 | 4;
    option_default_value: string;
    change_value_conf: 0 | 1;
    option_comment: string;
    tel_flg: 0 | 1;
    name_flg: 0 | 1;
    zip_code_flg: 0 | 1;
    address_flg: 0 | 1;
    space_flg: 0 | 1;
    mail_address_flg: 0 | 1;
    form_tel_flg: 0 | 1;
    multi_text_flg: 0 | 1;
    half_width_number_flg: 0 | 1;
    option_select: string[];
  }
) {
  try {
    const path = "tossUpForms/edit/optionNames";
    const bodys = { editIDs, select_option };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
// トスアップフォーム一括質問削除
export async function deleteTossUpFormOptions(
  editIDs: number[],
  delete_option_names: string[]
) {
  try {
    const path = "tossUpForms/edit/optionNames";
    const params = { editIDs, delete_option_names };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// トスアップフォーム一括質問削除前の質問名一覧取得
export async function getTossUpFormDeleteOptionNames(editIDs: number[]) {
  try {
    const path = "tossUpForms/edit/optionNames";
    const params = { editIDs };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const optionName: { option_name: string }[] = response.data.option_name;
    return optionName;
  } catch (error) {
    // logout();
    return [];
  }
}
